import { Injectable, OnDestroy, DOCUMENT, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class TitleNotificationService implements OnDestroy {
  private titleSrv = inject(Title);
  private document = inject<Document>(DOCUMENT);

  private readonly BLINK_INTERVAL = 1000;
  private readonly BLINK_TITLE = '🔔 New Notification';

  private originalTitle = '';
  private blinkTimer?: ReturnType<typeof setInterval>;
  private isBlinking = false;

  constructor() {
    this.document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  ngOnDestroy(): void {
    this.document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.stopBlink();
  }

  startBlink(): void {
    if (this.isBlinking || !this.document.hidden) {
      return;
    }
    this.isBlinking = true;
    this.originalTitle = this.titleSrv.getTitle();

    let toggle = false;
    this.blinkTimer = setInterval(() => {
      this.titleSrv.setTitle(toggle ? this.originalTitle : this.BLINK_TITLE);
      toggle = !toggle;
    }, this.BLINK_INTERVAL);
  }

  stopBlink(): void {
    if (!this.isBlinking) {
      return;
    }
    this.isBlinking = false;
    clearInterval(this.blinkTimer);
    this.blinkTimer = undefined;
    this.titleSrv.setTitle(this.originalTitle);
  }

  private readonly onVisibilityChange = (): void => {
    if (!this.document.hidden) {
      this.stopBlink();
    }
  };
}
